import { render, staticRenderFns } from "./ChatWindow.vue?vue&type=template&id=4ba0d637&"
import script from "./ChatWindow.vue?vue&type=script&lang=js&"
export * from "./ChatWindow.vue?vue&type=script&lang=js&"
import style0 from "./ChatWindow.vue?vue&type=style&index=0&id=4ba0d637&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ba0d637')) {
      api.createRecord('4ba0d637', component.options)
    } else {
      api.reload('4ba0d637', component.options)
    }
    module.hot.accept("./ChatWindow.vue?vue&type=template&id=4ba0d637&", function () {
      api.rerender('4ba0d637', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/delivery-dashboard/components/chat/ChatWindow.vue"
export default component.exports